const NAMESPACE = 'DELETE_LISTING';
const ACTIONS = {
    MODAL_CLOSE: `${NAMESPACE}_MODAL_CLOSE`,
    MODAL_OPEN: `${NAMESPACE}_MODAL_OPEN`
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    close: () => ({type: ACTIONS.MODAL_CLOSE}),
    open: ({boardId, hitTotal, idx, listingId}) => ({
        type: ACTIONS.MODAL_OPEN,
        payload: {boardId, hitTotal, idx, listingId}
    })
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing-delete-modal/actions.js